module.exports = __webpack_public_path__ + "img/p-10.7108ceff.png";